module.exports = __webpack_public_path__ + "static/logo-f290423e280f6ad83daeab4fd39f0825.png";